<template>
  <b-card>
    <b-form>
      <b-row>
        <!-- new password -->
        <!-- <b-col md="6">
          <b-form-group label-for="account-new-password">
            <label class="d-flex align-items-center">Currency</label>
            <b-form-select
              id="currencySelect"
              v-model="selectedCurrency"
              :options="currencyOptions"
            />
          </b-form-group>
        </b-col> -->
        <!--/ new password -->

        <b-col md="6">
          <b-form-group label-for="default-warehouse" label="Default Warehouse">
            <b-form-select
              id="defaultWarehouse"
              v-model="defaultWarehouse"
              :options="optionsWarehouseDLL"
            />
          </b-form-group>
        </b-col>


         <!-- VAT Number -->
         <b-col md="6">
          <b-form-group label-for="vat-number" label="VAT Number">
            <b-form-input
              id="vatNumber"
              v-model="vatNumber"
              placeholder="Enter VAT Number"
            />
          </b-form-group>
        </b-col>

        <!-- BRN -->
        <b-col md="6">
          <b-form-group label-for="brn" label="BRN">
            <b-form-input
              id="brn"
              v-model="brn"
              placeholder="Enter BRN"
            />
          </b-form-group>
        </b-col>


        <!-- buttons -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="changeCompanySettings()"
          >
            <b-spinner label="Spinning" v-if="showSpinner"></b-spinner>
            Save
          </b-button>
        </b-col>
        <!--/ buttons -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BSpinner,
  VBTooltip,
  BFormSelect,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import api from "@/api/api-v1-config";
import { mapGetters, mapActions } from "vuex";
import { CurrencySymbols } from "@/libs/defaultList";
import { fnSortingDropdown } from "@/libs/customFn";
export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BSpinner,
    BFormSelect,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      showSpinner: false,
      selectedCurrency: "MUR",
      defaultWarehouse: null,
      vatNumber: "",
      brn: "",
      currencyOptions: [],
      optionsWarehouse: [],
      currencyList: CurrencySymbols,
      tenantData: null,
      id:null,
    };
  },
  computed: {
    selectedCurrencySign() {
      return this.currencyList[this.selectedCurrency] || "Rs";
    },
    ...mapGetters("tenantModule", {
      tenantId: "tenantsId",
      loadingId: "loading",
    }),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      loading: "loading",
    }),
    optionsWarehouseDLL() {
      return fnSortingDropdown(this.optionsWarehouse);
    },
  },
  methods: {
    ...mapActions("tenantModule",["updateTenantDetailsAction", "getTenantIdAction"]), 
    ...mapActions("personalModule", ["changePasswordAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),


    async getProfile() {
      let conf = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      await api
        .get("/tenants/GetTenantDetails", conf)

        .then((response) => {
          if(response.data.result){
            this.id = response.data.result.id;
            this.vatNumber = response.data.result.vatNumber;
            this.selectedCurrency = response.data.result.currency;
            this.defaultWarehouse = response.data.result.purchaseWarehouseId;
            this.brn = response.data.result.brn;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async changeCompanySettings() {
      this.showSpinner = true;

      var userData = JSON.parse(localStorage.getItem("userData"));
      const initUserData = userData;
      const payload = {
        tenantId: localStorage.getItem('userTenant'),
        currency: this.selectedCurrency,
        purchaseWarehouseId: this.defaultWarehouse,
        vatNumber: this.vatNumber,
        brn: this.brn,
      };

      try {
        // Call Vuex action to update tenant details
        await this.updateTenantDetailsAction(payload);

        userData.brn = this.brn;
        userData.vat = this.vatNumber;
        
        localStorage.setItem("userData", JSON.stringify(userData));

        this.$bvToast.toast("Company settings updated successfully.", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        localStorage.setItem("userData", JSON.stringify(initUserData));
        this.$bvToast.toast("Error updating company settings.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.showSpinner = false;
      }
    },

    fnSortingDropdown(options, order, key) {
      return options.sort((a, b) => {
        const textA = a[key].toUpperCase();
        const textB = b[key].toUpperCase();
        return order === "asc"
          ? textA.localeCompare(textB)
          : textB.localeCompare(textA);
      });
    },
  },
  async mounted() {
      // Initialize currency options
      this.currencyOptions = Object.keys(this.currencyList).map((x) => {
        return { text: x, value: x };
      });

      // Sort currency options alphabetically
      this.currencyOptions = this.fnSortingDropdown(
        this.currencyOptions,
        "asc",
        "text"
      );

      await this.getWarehouseListAction().then(() => {
        this.warehouses.map((v, i) =>
          this.optionsWarehouse.push({
            value: v.id,
            text: `${v.name}`,
          })
        );
      });

    
    await this.getProfile();
      await this.getTenantIdAction(this.id).then((response) => {
      this.tenantData = this.tenantId;
      this.imageFile = "data:image/jpeg;base64," + this.tenantId.detailsDto.logo;
      this.modules.forEach((module) => {
        if (this.tenantData.modules.some((m) => m.id === module.id)) {
          module.isActive = true;
          this.selectedModules.push({
            isActive: true,
            name: module.name,
            id: module.id,
          });
        }
      });
    });
    },
    
};
</script>

